<template>
  <Chart :options="options" :updateArgs="updateArgs" />
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions from "@international-energy-agency/vue-ui/highcharts";
export default {
  props: {
    baseOptions: {
      type: Object,
      default: () => ({}),
    },
    updateArgs: {
      type: Array,
      default: () => [true, true, true],
    },
    palette: {
      type: String,
      default: "default",
      validator: (prop) =>
        ["default", "highlight", "light", "light-highlight", "tints"].includes(
          prop
        ),
    },
    stages: {
      type: Array,
      required: true,
    },
    stage: {
      type: Number,
      required: true,
    },
  },
  components: { Chart },
  computed: {
    options() {
      const { baseOptions, stages, stage } = this;
      return ChartOptions.buildOptions({ ...baseOptions, ...stages[stage] });
    },
  },
};
</script>
